import { Injectable } from '@angular/core';
import { Translation, TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root',
})
export class TranslocoPreloadService {
  constructor(private translocoService: TranslocoService) {}

  preloadTranslations(): Promise<Translation> {
    const defaultLang = this.translocoService.getActiveLang() || 'de';
    return this.translocoService.load(defaultLang).toPromise();
  }
}
